import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import McqHistory from "./McqHistory";

const ProfileHistory = () => {

  const navigate = useNavigate();

  useEffect(() => {

    const navbar =
      document.querySelector(".navbar");

    const handleScroll = () => {

      const currentScroll =
        window.pageYOffset;

      if (!navbar) return;

      if (currentScroll <= 10) {

        navbar.style.transform =
          "translateX(-50%) translateY(0)";

        navbar.style.opacity =
          "1";

      }

      else {

        navbar.style.transform =
          "translateX(-50%) translateY(-130%)";

        navbar.style.opacity =
          "0";

      }

    };

    if (navbar) {

      navbar.style.position =
        "fixed";

      navbar.style.top =
        "15px";

      navbar.style.left =
        "50%";

      navbar.style.width =
        "90%";

      navbar.style.maxWidth =
        "1100px";

      navbar.style.transform =
        "translateX(-50%)";

      navbar.style.zIndex =
        "9999";

      navbar.style.transition =
        "all 0.35s ease";

    }

    window.addEventListener(
      "scroll",
      handleScroll
    );

    return () => {

      window.removeEventListener(
        "scroll",
        handleScroll
      );

      if (navbar) {

        navbar.style.transform =
          "translateX(-50%) translateY(0)";

        navbar.style.opacity =
          "1";

      }

    };

  }, []);

  return (

    <div style={styles.container}>

      <div style={styles.card}>

        <McqHistory />

      </div>

    </div>

  );

};

export default ProfileHistory;

const styles = {

  container: {

    background: "#0f172a",

    minHeight: "100vh",

    padding: "20px",

    display: "flex",

    justifyContent: "center"

  },

  card: {

    background: "#1f2937",

    padding: "20px",

    borderRadius: "10px",

    color: "#fff",

    width: "100%",

    maxWidth: "900px"

  }

};
